/**
 * Centralised Partner API path constants.
 *
 * Single source of truth for endpoint paths — each one is passed straight into
 * `useBasicQuery`, which uses it both to build the request URL and as the
 * base of the query's cache key. Reused by mutation hooks too, so a mutation
 * can invalidate the matching query's cache without hardcoding the path a
 * second time.
 */

export const PARTNER_ORGANIZATIONS_PATH = 'api/v1/partner/organizations';
export const PARTNER_ORGANIZATION_PATH = 'api/v1/partner/organization';
export const PARTNER_TEAM_PATH = 'api/v1/partner/team';
export const PARTNER_TEAM_ROLES_PATH = 'api/v1/partner/team/roles';
export const PARTNER_TEAM_INVITATIONS_PATH = 'api/v1/partner/team/invitations';
export const PARTNER_API_KEYS_PATH = 'api/v1/partner/api-keys';
export const PARTNER_USERS_PATH = 'api/v1/partner/users';
export const PARTNER_COMPANIES_ALL_PATH = 'api/v1/partner/companies/all';
export const PARTNER_MESSAGES_TOTAL_PATH = 'api/v1/partner/reporting/messages/total';
export const PARTNER_BILLING_BULK_PATH = 'api/v1/partner/billing/bulk';
// Logs V1 (sc-44216/sc-44238).
export const PARTNER_LOGS_PATH = 'api/v1/partner/logs';
export const PARTNER_LOGS_EVENT_TYPES_PATH = 'api/v1/partner/logs/event-types';
